export default __webpack_public_path__ + "images/6dd8c4bdab401ca37470b41339298b7b-adoption-dog-667.png";